/* This is the EMIS School Building components */
/**This components need to generate 10 rows data to work well */
<template>
	<v-container>
		<div>
			<span v-html="title"></span>
		</div>
		<div>
			<table style="height: 43px;" width="450px;" border="1px;" cellspacing="0px;">
				<tbody>
					<tr>
						<td style="width: 250px; height: 25px; text-align: center; vertical-align: middle;">ស្ថានភាព</td>
						<td style="width: 100px; height: 25px; text-align: center; vertical-align: middle;">ចំនួន</td>
						<td style="width: 100px; height: 25px; text-align: center; vertical-align: middle;">ចំនួនបន្ទប់</td>
					</tr>
					<tr v-for="(value, row) in building.length" :key="row">
						<td style="width: 250px; height: 25px; text-align: left; vertical-align: middle;">
							{{ building[row] }}
						</td>
						<td v-for="(value, col) in data[row].dt.length" :key="col"
							:class="[ !buildingOnOff[row][col] ? 'row-data-gray' : 'row-data' ]">
							<numberinput v-model="data[row].dt[col]" :disabled="!buildingOnOff[row][col]" class="number"/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</v-container>
</template>

<script>
import { building, buildingOnOff } from '@/utils/ascf/commonConfig.js'
import NumberInput from '@/components/common/NumberInput.vue'
export default {
  props: ["data", "title"],
	components: {
		'numberinput': NumberInput
  },
  data() {
    return {
			building: building,
			buildingOnOff: buildingOnOff
    }
	}
}
</script>

<style scoped>
	.number {
		width:100px;
		text-align: center;
	}
	.row-data {
		width: 100px; 
		height: 25px; 
		text-align: center; 
		vertical-align: middle;
	}
	.row-data-gray {
		width: 100px; 
		height: 25px; 
		text-align: center; 
		vertical-align: middle;
		background-color: lightgray;
	}
</style>
